import React, { useEffect } from "react";
import {
  MuiTextField,
  MuiTypography,
  MuiGrid,
  MuiButton,
  MuiInputAdornment,
  MuiEmailIcon,
  MuiHomeIcon,
} from "../../../ui";
import theme from "../../../../assests";

import routes from "../../../navigation/Routes";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import spinner from '../../../ui/icons/spinner.gif'
import { MuiPaper, MuiTableContainer, MuiTable, MuiTableHead, MuiTableCell, MuiTableBody, MuiTableRow } from "../../../ui/MaterialUIComponents";
import DialogComponent from '../../school/teacher/DialogComponent';
import lodash from 'lodash'
import PageHeaderComponent from '../../../ui/PageHeaderComponent'

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles({
  tableCell: {
    minWidth: 240
  },
  tableCell_action: {
    minWidth: 200,
  },
});
function CreateAdmin(props) {
  const classes = useStyles();
  const [stateObj, setStateObject] = React.useState({
    firstName: "",
    lastName: "",
    adminCreationError: "",
    email: "",
    phoneNumber: "",
    showConfirmDialogForMakeOwner: false,
    showRevokeDialog: false,
    adminDetailsObj: {},
    showConfirmDialogForResend: false,
    showConfirmDialogForRemove: false,


  });

  const [errorObj, setError] = React.useState({ ...stateObj });


  const validate = (stateObj) => {
    let formValid = true;
    let errorObj = {};
    if (props.existingAdmins.some(existingAdmin => existingAdmin.email.toLowerCase() == stateObj.email.toLowerCase())) {
      errorObj.email = "Admin account already exists"
      formValid = false;
    }
    if (stateObj.email.toLowerCase() === props.userInformation.email.toLowerCase()) {
      errorObj.email = "This Email Is Registered As Owner"
      formValid = false;
    }
    if (stateObj.firstName == "") {
      errorObj.firstName = "Please Enter First Name"
      formValid = false;
    }
    if (stateObj.firstName.trim() != "") {
      if (!stateObj.firstName.match((/^[A-Za-z ]+$/))) {
        errorObj.firstName = "Please Enter Only alphabets For First Name"
        formValid = false;
      }
    }

    if (stateObj.lastName.trim() != "") {
      if (!stateObj.lastName.match((/^[A-Za-z ]+$/))) {
        errorObj.lastName = "Please Enter Only alphabets For Last Name"
        formValid = false;
      }
    }

    if (stateObj.lastName == "") {
      errorObj.lastName = "Please Enter Last Name"
      formValid = false;
    }
    if (stateObj.email.trim() == "") {
      errorObj.email = "Please Enter Email"
      formValid = false;
    }

    if (stateObj.phoneNumber != "") {
      if (stateObj.phoneNumber.length != 10) {
        errorObj.phoneNumber = "Please enter a valid phone number"
        formValid = false;
      }
    }
    if (stateObj.email != "") {
      if (!stateObj.email.match(/^([A-Za-z0-9\_\-\.])+\@([A-Za-z0-9\_\-\.])+\.([A-Za-z]{2,4})$/)) {
        errorObj.email = "Please enter a valid email"
        formValid = false;

      }
    }

    setError({ ...errorObj, errorObj: errorObj });
    return formValid;
  }
  const handleChange = name => event => {
    if (name === "email") {
      if (stateObj.email !== event.target.value) {
        setStateObject({ ...stateObj, adminCreationError: "" })
      }
    }

    setStateObject({ ...stateObj, [name]: event.target.value });


  };

  useEffect(() => {
    async function fetchData() {
      await props.fetchExistingAdmins(props.activeSchool._id);
    }
    fetchData();
  }, []);

  const showConfirmDialogForMakeOwnerOnClickOfOwner = (adminObj) => {
    setStateObject({ ...stateObj, showConfirmDialogForMakeOwner: true, adminDetailsObj: adminObj });
  }

  const closeDialog = () => {
    setStateObject({ ...stateObj, showConfirmDialogForMakeOwner: false });
  }

  const toggleDialogFlag = (flagName, adminObj) => {
    setStateObject({ ...stateObj, [flagName]: !stateObj[flagName], adminDetailsObj: adminObj });

  }
  const onClickOfMakeOwner = async () => {
    closeDialog()
    let data = { ...props.activeSchool };
    const i18n = props.i18n

    data.transferOwnerId = stateObj.adminDetailsObj._id;
    let result = await props.editSchoolInformation(props.userInformation._id, props.activeSchool._id, data);
    if (result.transferOwnerId != null) {
      let res = await props.sendEmail(stateObj.adminDetailsObj.email, data.transferOwnerId, props.activeSchool._id);
      if (res.message != null) {
        toast(i18n.toastMsgs.inviteSentSuceesfully);
      }
    }

    setStateObject({ ...stateObj, showConfirmDialogForMakeOwner: false });

  }

  const handleRevoke = async () => {
    closeDialog()
    let data = { ...props.activeSchool };
    data.transferOwnerId = null;

    let result = await props.editSchoolInformation(props.userInformation._id, props.activeSchool._id, data);
    if (result != null) {
      toast("Revoked");
    }
    ;
    setStateObject({ ...stateObj, showRevokeDialog: false });


  }
  const handleResend = async () => {
    let res = await props.sendEmail(stateObj.adminDetailsObj.email, props.activeSchool.transferOwnerId, props.activeSchool._id);
    if (res.message != null) {
      toast('Invite resent');
    }
    toggleDialogFlag("showConfirmDialogForResend")
  }

  const createAdmin = async () => {
    const i18n = props.i18n
    let tempData = { ...stateObj };
    tempData.schoolIds = [];
    tempData.schoolIds.push(props.activeSchool._id);
    tempData.createdBy = { "id": props.userInformation._id };
    if (tempData.phoneNumber !== "") {
      tempData.phoneNumber = "+91" + tempData.phoneNumber;
    }
    if (tempData.email !== undefined && tempData.email !== "") {
      tempData.email = tempData.email.toLowerCase();
    }
    let userData = JSON.stringify(tempData);
    let result = null;
    if (validate(stateObj) == true) {
      result = await props.createAdminInServer(props.userInformation._id, props.activeSchool._id, userData);

      if (!result.status) {
        errorObj.email = result.createAdminResult
        toast(i18n.toastMsgs.adminCreatationFailed);
        setError({ ...errorObj, errorObj: errorObj });
      } else {
        toast(i18n.toastMsgs.adminCreatedSuccessfully);
        await props.fetchExistingAdmins(props.activeSchool._id);
      }
    }
  };

  const handleRemove = async () => {
    const i18n = props.i18n
    for (let i = 0; i < stateObj.adminDetailsObj.profiles.length; i++) {
      let index = lodash.findIndex(stateObj.adminDetailsObj.profiles[i].schools, (o) => {
        return o == props.activeSchool._id
      });
      if (index != -1) {
        stateObj.adminDetailsObj.profiles[i].schools.splice(index, 1);
        let result = await props.deleteAdminProfile(stateObj.adminDetailsObj, props.userInformation._id, props.activeSchool._id);
        if (result != null) {
          result = {}
          toast(i18n.toastMsgs.adminRemovedSuccessFully)
        }
      }

    }
    toggleDialogFlag("showConfirmDialogForRemove")
    setStateObject({ ...stateObj, showConfirmDialogForRemove: false });
  }

  const isActiveSchoolPresentForAdmin = (adminObj) => {
    for (let i = 0; i < adminObj.profiles.length; i++) {
      let index = lodash.findIndex(adminObj.profiles[i].schools, (o) => {
        if (adminObj.isRegistrationPending === true) {
          adminObj.status = "Invited"
        } else {
          if (showRevokeRemoveBtn(adminObj)) {
            adminObj.status = "Invited"
          } else {
            adminObj.status = "Active"
          }
        }
        return o == props.activeSchool._id
      });
      if (index != -1) {
        return true;
      }


    }
    return false;
  }

  const showRevokeRemoveBtn = (row) => {
    if (row._id == props.activeSchool.transferOwnerId)
      return true;

    return false;
  }
  const { i18n } = props
  return (
    <React.Fragment >
      <MuiGrid container xs={12} style={{ marginTop: '75px' }} justify='center' alignItems='center'>
        {props.createAdminInProgress === true || props.updateSchoolinformationInProgress === true
          ?
          <MuiGrid >
            <img src={spinner} alt="none" style={theme.spinnerImgStyle} />
          </MuiGrid>
          :


          <MuiGrid container xs={11} >
            {
              stateObj.showConfirmDialogForMakeOwner &&
              <DialogComponent
                openDialog={stateObj.showConfirmDialogForMakeOwner}
                handleCloseDialog={closeDialog}
                title='Make Owner'
                handleClickOnYes={() => onClickOfMakeOwner(stateObj.adminDetailsObj)}
              />
            }
            {
              stateObj.showRevokeDialog &&
              <DialogComponent
                openDialog={stateObj.showRevokeDialog}
                title='Revoke Ownership'
                handleCloseDialog={() => toggleDialogFlag("showRevokeDialog")}
                handleClickOnYes={() => handleRevoke()}
              />
            }

            {
              stateObj.showConfirmDialogForResend &&
              <DialogComponent
                title='Resend Invite'
                openDialog={stateObj.showConfirmDialogForResend}
                handleCloseDialog={() => toggleDialogFlag("showConfirmDialogForResend")}
                handleClickOnYes={() => handleResend()}
              />
            }
            {
              stateObj.showConfirmDialogForRemove &&
              <DialogComponent
                title='Remove Admin'
                openDialog={stateObj.showConfirmDialogForRemove}
                handleCloseDialog={() => toggleDialogFlag("showConfirmDialogForRemove")}
                handleClickOnYes={() => handleRemove()}
              />
            }

            <MuiGrid xs={12}>
              <Link
                style={{ textDecoration: 'none', cursor: 'pointer' }}
                to={{
                  pathname: routes.main,
                }}
              ><MuiGrid container xs={12}>
                  <MuiGrid item >

                    <MuiHomeIcon color='primary' size='medium' />

                  </MuiGrid>

                  <MuiGrid item  >
                    <MuiTypography align="left" variant={theme.typographyStyles.H3} color='primary' >
                      &nbsp;&nbsp;{props.activeSchool.name}
                    </MuiTypography>
                  </MuiGrid> </MuiGrid>    </Link>
            </MuiGrid>

            <MuiGrid container xs={12} style={{ padding: '10px 0px' }}>
              <PageHeaderComponent {...props} title={i18n.createadmin.title} subTitle={i18n.createadmin.subTitle} />

            </MuiGrid>

            <MuiGrid container xs={12} direction="row" justify="flex-start" >
              <MuiGrid container xs={12} direction="row" justify="flex-start">
                <MuiGrid container item xs={9} direction="row" justify="space-between" >
                  {/* <MuiTypography> */}
                  {/* <MaterialUIForm > */}
                  <MuiGrid container xs >
                    <MuiGrid item xs={11}>
                      <MuiTextField
                        id="firstName"
                        label="First Name"
                        style={{ width: "100%" }}
                        onChange={handleChange("firstName")}
                        margin="normal"
                        placeholder="Enter first name"
                        type="text"
                        required
                      />   </MuiGrid>
                    <MuiGrid container justify='flex-start' xs={11}>
                      <MuiTypography variant="caption" color="error">{errorObj.firstName}</MuiTypography>
                    </MuiGrid>
                  </MuiGrid>
                  <MuiGrid container xs>
                    <MuiGrid item xs={11}>
                      <MuiTextField
                        id="lastName"
                        label="Last Name"
                        style={{ width: "100%" }}
                        onChange={handleChange("lastName")}
                        margin="normal"
                        placeholder="Enter last name"
                        type="text"
                        required
                      />    </MuiGrid>
                    <MuiGrid container justify='flex-start' xs={11}>
                      <MuiTypography variant="caption" color="error">{errorObj.lastName}</MuiTypography>
                    </MuiGrid>
                  </MuiGrid>

                  <MuiGrid container xs>
                    <MuiGrid item xs={11}>
                      <MuiTextField
                        id="email"
                        label="Email"
                        style={{ width: "100%" }}
                        onChange={handleChange("email")}
                        margin="normal"
                        placeholder="Enter Email"
                        type="email"
                        data-validators="isRequired, isEmail"
                        required
                        InputProps={{
                          endAdornment: (
                            <MuiInputAdornment position="end">
                              <MuiEmailIcon color="primary" />
                            </MuiInputAdornment>
                          )
                        }}
                      />
                    </MuiGrid>
                    <MuiGrid container justify='flex-start' xs={11}>
                      <MuiTypography variant="caption" color="error">{errorObj.email}</MuiTypography>
                      {stateObj.adminCreationError !== undefined && <MuiTypography variant="caption" color="error" >{stateObj.adminCreationError}</MuiTypography>}
                    </MuiGrid>

                  </MuiGrid>            </MuiGrid>
                <MuiGrid style={{ paddingTop: 30 }}>

                  <MuiButton
                    id="createAdmin"
                    style={theme.primaryButtonStyle}
                    onClick={() => createAdmin()}
                  >
                    {i18n.createadmin.createAdmin}
                  </MuiButton>


                </MuiGrid>

                <br />
                <br />
              </MuiGrid>


              {props.existingAdmins.length > 0 && <MuiGrid item >

                <MuiGrid item container justify="flex start" style={{ padding: '15px 0px' }}>
                  <MuiTypography variant={theme.typographyStyles.H5} color='primary'>{i18n.createadmin.existingAdmins}</MuiTypography>
                </MuiGrid>
                <MuiTableContainer>
                  <MuiTable className={props.table} aria-label="simple-table">
                    <MuiTableHead style={theme.tableHeaderStyle1} >
                      <MuiTableCell className={classes.tableCell} align="center" style={theme.tableHeaderTextStyle} > {i18n.createadmin.name}</MuiTableCell>
                      <MuiTableCell className={classes.tableCell} align="center" style={theme.tableHeaderTextStyle}> {i18n.createadmin.email}</MuiTableCell>
                      <MuiTableCell className={classes.tableCell} align="center" style={theme.tableHeaderTextStyle}> {i18n.createadmin.status}</MuiTableCell>
                      <MuiTableCell className={classes.tableCell_action} align="center" style={theme.tableHeaderTextStyle}> {i18n.createadmin.actions}</MuiTableCell>
                    </MuiTableHead>
                    <MuiTableBody>
                      {props.existingAdmins.map(row => (

                        isActiveSchoolPresentForAdmin(row) &&
                        <MuiTableRow>

                          <MuiTableCell className={classes.tableCell} align="center" style={theme.typography.body1}>
                            {row.firstName + " " + row.lastName}
                          </MuiTableCell >
                          <MuiTableCell className={classes.tableCell} align="center" style={theme.typography.body1}>
                            {row.email}
                          </MuiTableCell >
                          <MuiTableCell className={classes.tableCell} align="center" style={theme.typography.body1}>{row.status}</MuiTableCell>
                          <MuiTableCell className={classes.tableCell_action} align="center" >
                            {/* {row._id == props.activeSchool.transferOwnerId */}
                            {row.isRegistrationPending === false ?
                              <MuiGrid>{showRevokeRemoveBtn(row)
                                ?
                                <MuiGrid container justify="center" alignItems="center" spacing={1} >
                                  <MuiGrid item >
                                    <MuiButton style={theme.createAdminButton} onClick={() => toggleDialogFlag("showRevokeDialog", row)}>Revoke</MuiButton>
                                  </MuiGrid>
                                  <MuiGrid item >
                                    <MuiButton style={theme.createAdminButton} onClick={() => toggleDialogFlag("showConfirmDialogForResend", row)}>Resend</MuiButton>
                                  </MuiGrid>
                                </MuiGrid>
                                //                          
                                :
                                <MuiGrid container justify="center" alignItems="center" spacing={1}>
                                  {props.activeSchool.hasOwnProperty('transferOwnerId') == false || props.activeSchool.transferOwnerId == null}
                                  <MuiGrid item >
                                    <MuiButton style={theme.createAdminButton} onClick={() => toggleDialogFlag("showConfirmDialogForRemove", row)}>Remove</MuiButton>
                                  </MuiGrid>
                                  {
                                    (props.activeSchool.hasOwnProperty('transferOwnerId') == false || props.activeSchool.transferOwnerId == null) &&
                                    <MuiGrid item>
                                      <MuiButton style={theme.createAdminButton} onClick={() => showConfirmDialogForMakeOwnerOnClickOfOwner(row)}>Make Owner</MuiButton>
                                    </MuiGrid>
                                  }
                                </MuiGrid>
                              } </MuiGrid>
                              : <MuiGrid container justify="center" alignItems="center" spacing={1}>
                                <MuiGrid item >
                                  <MuiButton style={theme.createAdminButton} onClick={() => toggleDialogFlag("showConfirmDialogForRemove", row)}>Remove</MuiButton>
                                </MuiGrid>
                              </MuiGrid>}
                          </MuiTableCell>
                        </MuiTableRow>
                      )
                      )}
                    </MuiTableBody>
                  </MuiTable>
                </MuiTableContainer>
              </MuiGrid>}
            </MuiGrid>
          </MuiGrid>
        }
      </MuiGrid>
    </React.Fragment>
  );
}

export default CreateAdmin;